import { NextSeo } from "next-seo";
import React from "react";

const NextHelmet = (props) => {
  return (
    <NextSeo
      defaultTitle="DS4U tracking"
      title={
        props.title
          ? `DS4U tracking | ${props.title}`
          : "DS4U tracking"
      }
      description={
        props.description ? props.description : "DS4U tracking"
      }
      additionalMetaTags={[
        {
          property: "keywords",
          content: "DS4U trackinga",
        },
      ]}
    />
  );
};

export default React.memo(NextHelmet);
